import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";

const UIButton = ({
  title = "",
  loading = false,
  variant = "contained",
  children,
  size = "small",
  sx = {},
  disabled = false,
  fullWidth = false,
  ...rest
}) => {
  return (
    <Button
      fullWidth={fullWidth}
      variant={variant}
      disabled={disabled || loading}
      sx={{
        minWidth: "10px",
        textTransform: "none",
        fontSize: "1rem",
        fontWeight: "normal",
        ...sx,
      }}
      size={size}
      {...rest}
    >
      {children || title}
      {loading && (
        <CircularProgress
          sx={{ ml: 1, color: "var(--palette-secondary_button_text)" }}
          size={18}
        />
      )}
    </Button>
  );
};

export default UIButton;
